<div class="flex flex-col">
    @if (loading) {
        <mat-progress-bar class="absolute inset-x-0 top-0 h-0.5" [mode]="'indeterminate'"></mat-progress-bar>
    }
    <!-- Header -->
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'holidayCalendar.new' | transloco }}</div>
        <div class="flex items-center">
            @if (!loading && !readonly) {
                <button mat-stroked-button class="block 5xl:hidden text-on-primary mr-4" (click)="accept()">
                    {{ 'accept' | transloco }}
                </button>
            }
            <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>

    <div class="flex justify-center items-center gap-2 w-full mb-4">
        <button mat-icon-button (click)="previousYear()">
            <mat-icon [svgIcon]="'mat_outline:chevron_left'"></mat-icon>
        </button>
        {{ year }}
        <button mat-icon-button (click)="nextYear()" [disabled]="disableNextYear">
            <mat-icon [svgIcon]="'mat_outline:chevron_right'"></mat-icon>
        </button>
    </div>
    <div class="flex flex-col w-full gap-4">
        @for (row of months(); track row) {
            <div class="flex w-full justify-center gap-4">
                @for (month of row; track month) {
                    <mat-card class="bg-gray-50 dark:bg-slate-900 p-2 w-80 max-w-1/4">
                        <mat-calendar #calendar [startAt]="getStartDate(month)" [maxDate]="getMaxDate(month)" [minDate]="getMinDate(month)"
                            (selectedChange)="select($event, calendar)" [dateClass]="isInRange" [dateFilter]="dateFilter"></mat-calendar>
                    </mat-card>
                }
            </div>
        }
    </div>

    @if (!loading && !readonly) {
        <div class="hidden 5xl:flex justify-end p-4 sticky bottom-0">
            <button class="mr-2" mat-raised-button color="warn" (click)="closeDialog()">
                {{ 'cancel' | transloco }}
            </button>
            <button class="mr-2" mat-raised-button color="primary" (click)="accept()" [disabled]="formGroup.invalid">
                {{ 'accept' | transloco }}
            </button>
        </div>
    }
</div>
    